module.exports = __webpack_public_path__ + "img/quote-default-image.b2edf08c.png";